/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { FacebookBusinessPageData } from 'cio/services/facebook-lead-ads';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import AuthService from 'cio/services/auth';
import { action } from '@ember/object';

interface FormsFacebookLeadAdsConnectPageModalArgs {
  onClose: () => unknown;
  submitTask: Task<unknown, [string]>;
  facebookPages: FacebookBusinessPageData[];
  facebookAccountName: string;
  fetchMorePages: () => unknown;
}

export default class FormsFacebookLeadAdsConnectPageModal extends Component<FormsFacebookLeadAdsConnectPageModalArgs> {
  @service auth!: AuthService;
  @service analytics!: AnalyticsService;

  @tracked selectedPage: { id: string; name: string } | null = null;

  constructor(owner: unknown, args: FormsFacebookLeadAdsConnectPageModalArgs) {
    super(owner, args);

    this.analytics.track('facebook_lead_ads', 'connect_business_page_started');

    if (this.hasOnlyOneFacebookPage) {
      this.selectedPage = this.args.facebookPages[0];
    }
  }

  get selectedPageName() {
    if (!this.selectedPage) {
      return '';
    }
    return this.selectedPage.name;
  }

  get hasOnlyOneFacebookPage() {
    return this.args.facebookPages.length === 1;
  }

  get facebookPagesSelectable() {
    return [
      ...this.args.facebookPages.map(({ name, id }) => ({
        name,
        id,
      })),
    ];
  }

  @action
  onChange(page: { id: string; name: string }) {
    this.selectedPage = page;
  }
}
